'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { getENV } from '../../utils/env';
import { useConsentGatedHtml } from '../hooks';
type LocalAdProps = {
  onDone: () => void;
};
const LOCAL_AD_DONE_EVENT = 'velocity:local-ad:done';
type FlippBootstrapParams = {
  accessToken: string;
  merchantId: string;
  merchantName: string;
};
const getFlippBootstrapScript = ({
  accessToken,
  merchantId,
  merchantName
}: FlippBootstrapParams) => {
  const scriptSrc = `https://aq.flippenterprise.net/${merchantId}/iframe.js`;
  return `
(function() {
  var scriptId = 'flipp-storefront-script';
  var doneEventName = '${LOCAL_AD_DONE_EVENT}';

  function dispatchDone() {
    window.dispatchEvent(new CustomEvent(doneEventName));
  }

  function renderStorefront() {
    try {
      var flippContainer = document.querySelector('#flipp-container');
      if (!flippContainer || !window.Flipp || !window.Flipp.Storefront) {
        dispatchDone();
        return;
      }

      var storefront = new Flipp.Storefront({
        accessToken: ${JSON.stringify(accessToken)},
        merchantId: ${JSON.stringify(merchantId)},
        merchantNameIdentifier: ${JSON.stringify(merchantName)},
        locale: 'en-CA'
      });

      storefront.renderStorefront(flippContainer);
      dispatchDone();
    } catch (error) {
      dispatchDone();
    }
  }

  var existingScript = document.getElementById(scriptId);

  if (existingScript) {
    if (window.Flipp && window.Flipp.Storefront) {
      renderStorefront();
      return;
    }

    existingScript.addEventListener('load', renderStorefront, { once: true });
    existingScript.addEventListener('error', dispatchDone, { once: true });
    return;
  }

  var script = document.createElement('script');
  script.id = scriptId;
  script.src = ${JSON.stringify(scriptSrc)};
  script.async = true;
  script.onload = renderStorefront;
  script.onerror = dispatchDone;
  document.body.appendChild(script);
})();
`;
};
export const LocalAdV2 = t0 => {
  const $ = _c(7);
  const {
    onDone
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getENV("NEXT_PUBLIC_FLIPP_ACCESS_TOKEN");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const accessToken = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = getENV("NEXT_PUBLIC_FLIPP_MERCHANT_ID");
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const merchantId = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = getENV("NEXT_PUBLIC_FLIPP_MERCHANT_NAME");
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const merchantName = t3;
  const isEnabled = Boolean(accessToken && merchantId && merchantName);
  const html = isEnabled ? "<div id=\"local-ad-flipp-marker\"></div>" : "";
  let t4;
  let t5;
  if ($[3] !== onDone) {
    t4 = () => {
      window.addEventListener(LOCAL_AD_DONE_EVENT, onDone);
      return () => {
        window.removeEventListener(LOCAL_AD_DONE_EVENT, onDone);
      };
    };
    t5 = [onDone];
    $[3] = onDone;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      html,
      isEnabled,
      consentGroup: "C0003",
      dedupeId: "local-ad-flipp-marker",
      onReady: () => {
        if (!isEnabled || document.getElementById("flipp-bootstrap-runner")) {
          return;
        }
        const script = document.createElement("script");
        script.id = "flipp-bootstrap-runner";
        script.textContent = getFlippBootstrapScript({
          accessToken,
          merchantId,
          merchantName
        });
        document.body.appendChild(script);
      }
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  useConsentGatedHtml(t6);
  return null;
};